import React from "react";
import styles from './status.module.scss';

function Subscriptions(props) {
  let { data } = props;
  if (data === 'M') {
    data = "Monthly";
  } else if (data === "Y") {
    data = "Yearly";
  } else if (data === 'Q') {
    data = "Quarterly";
  } else if (data === 'H') {
    data = "Half Yearly";
  }
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.status} ${styles[data?.replaceAll(" ", '')]}`}>
        <div className={styles.text}>{data}</div>
      </div>
    </div>

  );
}
export default Subscriptions;
